import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '~/utils/auth/firebase-service';
import { getProfile } from '~/utils/ServerRequest';

/**
 * Redirects to /informationForm if authenticated and postSignupComplete is not true (false, null, undefined).
 * Should be called at the top of every page or in the main layout.
 */
export function usePostSignupRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkAndRedirect = async () => {
      const user = auth.currentUser;
      if (!user) return;
      // Don't redirect if already on /informationForm
      if (location.pathname === '/informationForm') return;
      try {
        const profile = await getProfile();
        // Defensive: treat missing or false as incomplete
        if (!profile || !('postSignupComplete' in profile) || !profile.postSignupComplete) {
          navigate('/informationForm', { replace: true });
        }
      } catch (err) {
        // If profile fetch fails, treat as incomplete
        navigate('/informationForm', { replace: true });
      }
    };
    checkAndRedirect();
    // Only run on mount and when auth state changes
  }, [location.pathname]);
}
